import * as React from "react";

function SvgIcons8MicrosoftEdge(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#1976D2"
        d="M13.3 15.1C8.7 17.9 6 21.9 6 21.9s.7-8.4 7.3-13.3c2.6-2 6.2-3.6 11-3.6 1.8 0 5.6.3 9 2.4s4.8 3.8 6.4 6.3c.7 1.1 1.2 2.5 1.5 3.8.6 2.5.7 5.6.7 5.6V27H17s-.1 8.1 11.2 8.1c3.9 0 5.3-.6 6.6-1 2-.6 4.2-2.1 4.2-2.1v8s-4.9 3-11.9 3c-2 0-4-.2-6-.8-1.7-.6-5.4-2-7.8-5.5-.9-1.2-1.8-2.9-2.3-4.5-.5-1.7-.5-3.4-.5-4.3 0-3.5 1.2-6.8 3.3-9.2C16.6 15.6 20 14 20 14s-3 2.8-3 6h14s.1-8-7.7-8c-3.2 0-7.2 1.4-10 3.1z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8MicrosoftEdge);
